import { call, put, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  set as setSearch
} from 'store/redux/search'
import {
  addArray as addUsersArray
} from 'store/redux/users'
import camelCaseKeys from 'utils/camelCaseKeys'

export default function * fetchSearchUsers (action) {
  const { refresh, boardId, limit } = action.payload

  if (refresh) {
    yield put(setSearch({
      users: [],
      usersCursor: null,
      usersTotalCount: null,
      usersLoadedAll: false,
      usersLoading: true
    }))
  } else {
    yield put(setSearch({
      usersLoading: true
    }))
  }

  const state = yield select()

  const { query, limitToBoard, users, usersCursor } = state.kanbo.search

  try {
    const { Users, Cursor, Refiners, SortOptions, TotalRows } = yield call(apiGetData, 'SearchUsers', {
      query,
      cursor: usersCursor,
      limit,
      boardId: (boardId && limitToBoard) ? boardId : null
    })

    yield put([
      addUsersArray(Users.map(User => ({
        id: User.Id,
        name: User.Name,
        email: User.Email,
        profileKey: User.ProfileKey,
        licenseType: User.LicenseType,
        isActive: User.Active,
        isLoaded: true,
        isLoading: false
      }))),
      setSearch({
        users: [
          ...users,
          ...Users.map(User => User.Id)
        ],
        usersCursor: Cursor,
        usersRefiners: Refiners ? camelCaseKeys(Refiners) : [],
        usersSortOptions: SortOptions ? camelCaseKeys(SortOptions) : [],
        usersTotalCount: TotalRows,
        usersLoadedAll: !Cursor,
        usersLoading: false
      })
    ])
  } catch (error) {
    yield put(setSearch({
      usersLoading: false
    }))

    throw error
  }
}
